<template>
  <div class="intro-content pt--40">
    <div class="profile profile--vertical profile--lg mb--20">
      <figure class="profile__avatar">
        <span class="profile__avatar__img"><img :src="avatar" :alt="user.nick"/></span>
      </figure>

      <div class="profile__text">
        <div class="profile__name">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  computed: {
    ...mapGetters('auth', [
      'user',
      'avatar',
    ]),
  },
}
</script>